import { useState } from "react";
import { useLocation } from 'react-router-dom';
import { Tab, Row, Card, Tabs, Col } from "react-bootstrap";
import CDAProdDataSubmission from "./Component/Prod/CDAProdDataSubmission";
import AltTestDataSubmission from "./Component/Test/AltTestDataSubmission";
import AltProdDataSubmission from "./Component/Prod/AltProdDataSubmission";
/**
 * Container of the Alt Batch page
 */
const AltDataSubmission = () => {

  const location = useLocation();
  const passedData = location.state;
  // Tab switch: Test & Prod
  const [tab, setTab] = useState(passedData?.envKey ? passedData.envKey : "altTest");

  return (
    <>
      <Row >
        <Col xl={11} lg={11} md={11} sm={12}>
          <Card className="p-4">
            <Card.Body className="text-start">
              <h1 id="mainContent" className="text-start header1 mb-3 blue bold">Alternate Data Submission</h1>
              <Tabs
                id="controlled-tab"
                activeKey={tab}
                onSelect={(k) => setTab(k)}
              >
                <Tab eventKey="altTest" title={"Test Data"}>
                  {tab === "altTest"
                    ? <AltTestDataSubmission />
                    : ""
                  }
                </Tab>
                <Tab eventKey="altProd" title={"Production Data"}>
                  {tab === "altProd"
                    ? <AltProdDataSubmission />
                    : ""
                  }
                </Tab>
              </Tabs>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default AltDataSubmission;